import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getReturnModes, getStoreList } from '../../../../actionCreators/returnExchange';
import { getReturnOrderConfig } from '../../../../actionCreators/myAccount';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import ReturnMethod from './ReturnMethod';

function ReturnChooseMode(props) {
  const data = sessionStorageHelper.getItem('returnStep') || {};
  const returnStore = sessionStorageHelper.getItem('returnStore') || {};
  const returnAddress = sessionStorageHelper.getItem('returnUserAddress') || {};
  const [renderMethods, setRenderMethods] = useState('');
  const [allModesDisable, setAllModesDisable] = useState(true);
  const [returnMode, setReturnMode] = useState(data.returnMode || '');
  const {
    orderDetails,
    getReturnModes,
    setFifthStep,
    setFourthStep,
    returnModes,
    getStoreList,
    dataLocale,
    storeList,
    setFinalStep,
    returnConfig,
    loadingNearByStore,
    exchangeNewFlow,
    userAddress,
    loading,
    isExpandable,
    setIsExpandable,
    showREtype,
    setThirdStep,
  } = props;
  let placeholder;
  const { RETURN_MODE, HOW_DO_YOU_WISH_TO_RETURN_THE_ITEM, CHANGE, SHIP_PRODUCT_TO_LENSKART } =
    dataLocale;
  let address = '';
  if (returnAddress) {
    if (returnAddress.addressline1) address += `${returnAddress.addressline1} `;
    if (returnAddress.addressline2) address += `${returnAddress.addressline2} `;
    if (returnAddress.city) address += `${returnAddress.city} `;
    if (returnAddress.state) address += `${returnAddress.state} `;
    if (returnAddress.postcode) address += returnAddress.postcode;
  }
  const [nearByAddress, setNearByAddress] = useState(
    returnStore?.selectedStore?.address || address
  );

  useEffect(() => {
    if (!returnConfig) {
      props.getReturnOrderConfig();
    }
  }, []);

  const shippingAddress =
    orderDetails &&
    orderDetails.result &&
    orderDetails.result.orders &&
    orderDetails.result.orders[0] &&
    orderDetails.result.orders[0].shippingAddress;
  useEffect(() => {
    if (shippingAddress && shippingAddress.postcode) {
      getReturnModes(shippingAddress?.postcode);
      getStoreList(shippingAddress?.postcode);
    }
  }, [shippingAddress]);

  const updateMethods = nearestStoreDistance => {
    const { returnMethods = [] } = returnModes;
    let modeOfReturn;
    if (returnConfig) {
      modeOfReturn = returnConfig.chooseModeOfReturn;
    }
    let allModesDisabled = true;
    const isWarehouseReturnDenied = returnMethods.some(method => {
      return ['store_return', 'schedule_pickup'].includes(method.name) && method.enabled;
    });
    const renderReturnMethods = returnMethods.reduce((memo, method) => {
      const { name, enabled } = method;
      const returnMode = modeOfReturn[name] ? { ...modeOfReturn[name] } : null; // to avoid change original object
      if (returnMode) {
        if (name === 'warehouse_return' && isWarehouseReturnDenied) {
          return memo;
        }
        if (enabled && allModesDisabled) {
          allModesDisabled = false;
        }
        returnMode.id = name;
        returnMode.error = returnMode.error || {};
        returnMode.error.status = !enabled;
        returnMode.subText = { ...returnMode.subText };
        if (!enabled) {
          returnMode.badge = '';
          if (name === 'store_return') {
            returnMode.subText = null;
          }
        }
        if (
          name === 'store_return' &&
          enabled &&
          nearestStoreDistance &&
          returnMode.subText &&
          returnMode.subText.contents &&
          returnMode.subText.contents.length
        ) {
          returnMode.subText.contents = returnMode.subText.contents.map(content => {
            return content.replace(
              'a few km',
              `<span class="text-color_grey_black fw700">${nearestStoreDistance}</span>`
            );
          });
        }
        memo.push(returnMode);
      }
      return memo;
    }, []);
    setRenderMethods(renderReturnMethods);
    setAllModesDisable(allModesDisabled);
  };

  useEffect(() => {
    if (returnModes && storeList && storeList.stores && storeList.stores.length) {
      const storeDetails = storeList.stores[0];
      const { distance } = storeDetails;
      const nearestStoreDistance = distance && distance.humanReadable;
      if (returnModes && returnModes.returnMethods) {
        updateMethods(nearestStoreDistance);
      }
    }
    if (!storeList) {
      updateMethods('');
    }
  }, [storeList, returnModes]);

  if (!returnModes || !returnModes.returnMethods) {
    placeholder = returnConfig && returnConfig.returnMethodsPlaceholder;
  }

  const handleChange = () => {
    setIsExpandable(RETURN_MODE);
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    returnStep = {
      ...returnStep,
      setStoreAddress: false,
    };
    sessionStorageHelper.setItem('returnStep', returnStep);
  };
  return (
    <div>
      <div className="bora-8 margin-10 order-box">
        <div className={`padding-15 ${isExpandable !== RETURN_MODE ? 'bg-white' : 'bg-cyan'}`}>
          <span
            className={`fs15 futur-std ${
              isExpandable !== RETURN_MODE ? 'text-color-grey fw500' : 'fw600'
            }`}
          >
            {HOW_DO_YOU_WISH_TO_RETURN_THE_ITEM}
          </span>
          {isExpandable !== RETURN_MODE && (
            <span
              className="float-right margin-r10 text-uppercase text-link"
              onClick={handleChange}
            >
              {CHANGE}
            </span>
          )}
          {isExpandable !== RETURN_MODE && (
            <div className="margin-t5">
              <span className="margin-l20">{returnMode}</span>
              {returnMode !== SHIP_PRODUCT_TO_LENSKART && (
                <span className="margin-l8 text-color-grey">{nearByAddress}</span>
              )}
            </div>
          )}
        </div>
        {isExpandable === RETURN_MODE && (
          <ReturnMethod
            allModesDisable={(placeholder && true) || allModesDisable}
            dataLocale={dataLocale}
            exchangeNewFlow={exchangeNewFlow}
            loading={loading}
            loadingNearByStore={loadingNearByStore}
            modes={renderMethods}
            nearByAddress={nearByAddress}
            placeholder={placeholder}
            returnConfig={returnConfig}
            setFifthStep={setFifthStep}
            setFinalStep={setFinalStep}
            setFourthStep={setFourthStep}
            setIsExpandable={setIsExpandable}
            setNearByAddress={setNearByAddress}
            setReturnMode={setReturnMode}
            setThirdStep={setThirdStep}
            showREtype={showREtype}
            updateMethods={updateMethods}
            userAddress={userAddress}
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  returnModes: state.returnExchange.returnModes,
  returnConfig: state.myAccount.returnConfig,
  loading: state.returnExchange.loading,
  userAddress: state.returnExchange.userAddress,
  exchangeNewFlow: state.returnExchange.exchangeNewFlow,
  loadingNearByStore: state.returnExchange.loadingNearByStore,
  orderDetails: state.order.orderDetails,
  dataLocale: state.locale,
  storeList: state.returnExchange.nearbyStore && state.returnExchange.nearbyStore.result,
});

function mapDispatchToProps(dispatch) {
  return {
    getReturnModes: pincode => dispatch(getReturnModes(pincode)),
    getStoreList: postcode => dispatch(getStoreList(postcode)),
    getReturnOrderConfig: () => dispatch(getReturnOrderConfig()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnChooseMode);
